import React, { useContext, useEffect, useState } from "react";
import { ReactChildrenProps } from "ecom-teams-apps-core";
import OutsideMsTeams from "../outsideMsTeams/OutsideMsTeams";
import { HVCThemeProvider } from "../../msTeamsUI/lib/withTheme";
import { MsTeamsContext } from "msTeams/store";

const PersonalApp: React.FC<ReactChildrenProps> = ({ children }) => {
    const msTeamsContext = useContext(MsTeamsContext);

    return (
        <HVCThemeProvider themeName={msTeamsContext.currentMsTeamsThemeName}>
            {msTeamsContext.isAppInsideMsTeams || process.env.REACT_APP_USE_WITH_NO_TEAMS === "true" ? (
                children
            ) : (
                <OutsideMsTeams />
            )}
        </HVCThemeProvider>
    );
};

export default PersonalApp;
